module.exports = ng.material.input;